
<div class="right-panel h-100">
  <div class="right-side">
    <div class="sessionProcess">
      <div class="actionBar d-flex" style="height: 1.6rem">
        <!-- <div>Unique User Processes Across All Workstations</div>-->
        <div class="flex-grow-1">
          <input class="searchBar float-start custom-placeholder" type="text" placeholder="Search by name" [(ngModel)]="filterText" (ngModelChange)='applyFilter()' style=" margin-bottom: 9px;" />
        </div>
        <!--<select name="status" class="searchFilter" id="" [(ngModel)]='filterSessionState' (ngModelChange)='applyFilter()'>
    <option value="All" [selected]="filterSessionState == 'All'">All States</option>
    <option *ngFor="let n of avlSessionStatesForFilter" value="{{ n }}">{{ n }}</option>
  </select>-->
  
        <mat-button-toggle-group name="status"
                                 [(ngModel)]="filterProcessState"
                                 (change)="applyFilter()"
                                 style="height: 1.8rem; border-radius: 4px; border: 1px solid #0d6efd; margin-top: 2px; margin-bottom: 5px; "
                                 aria-label="Status Toggle">
          <mat-button-toggle value="All" [checked]="filterProcessState === 'All'" >
            All
          </mat-button-toggle>
          <mat-button-toggle value="True" [checked]="filterProcessState === 'True'" >
            Tracked
          </mat-button-toggle>
          <mat-button-toggle value="False" [checked]="filterProcessState === 'False'" >
            Untracked
          </mat-button-toggle>
        </mat-button-toggle-group>

        <button type="button"
                class="actionBtn"
                (click)="resetFilter()"
                #btnResetFilter
                triggers="hover" ngbTooltip="Reset applied Filters">
          <span class="bi bi-x-lg text-danger" style=" margin-left: 0px; margin-top: 4px;font-size:smaller;"></span>

        </button>
        <button class="actionBtn" (click)="makeTracked()" *ngIf="showTrackUntrack && isMonitor == false">
          <span class="bi bi-box-arrow-down"
                aria-hidden="True"
                triggers="hover" ngbTooltip="Track"
                style="margin-right: 5px; margin-top:2px;"></span>
        </button>
        <button class="actionBtn" (click)="makeUntracked()" *ngIf="showTrackUntrack && isMonitor == false">
          <span class="bi bi-box-arrow-in-up"
                aria-hidden="True"
                triggers="hover" ngbTooltip="Untrack"
                style="margin-right: 5px"></span>
        </button>
      </div>
      <div class="listTable">
        <div style="min-height: 203px">
          <table style="border-collapse: collapse"
                 class="table table-hover "
                 cellspacing="0">
            <thead>
              <tr class="table-list-head">
                <th *ngIf="isMonitor == false">
                  <input type="checkbox" [checked]="selectAll"
                         id="" class="selectAllCheckBox"
                         title="Select All"
                    (change)="onSelectAllCheckBox($event)">
                </th>
                <th scope="col" resizable>Name</th>
                <th scope="col" resizable>Tracked</th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-list-row" *ngFor="let proc of applyFilter()
                  | paginate: { itemsPerPage: 10, currentPage: p };
                  let i = index" style="cursor: pointer;">
                <td *ngIf="isMonitor == false">
                    <input type="checkbox" title="Select Process"
                           class="selectCheckbox"
                           (click)="checkSelectedCheckboxes($event, proc.processName)"
                           [checked]="selectedProcs.includes(proc.processName)"
                           >
                </td>
                <td>{{ proc.processName }}</td>
                <td>{{ proc.isTracked}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <pagination-controls *ngIf="available"
                             class="my-pagination"
                             (pageChange)="p = $event" style="padding-bottom: 1.5rem;"></pagination-controls>

        <p *ngIf="available == false" style="text-align: center; margin-top: 5%;">No Processes Available To Monitor.</p>
      </div>

    </div>
  </div>
  <ngx-spinner bdColor="rgba(0,0,0,0)" size="default" color="var(--s-primary-color)" type="ball-spin" [fullScreen]="false"><p class="pleaseWait"> Please wait ... </p></ngx-spinner>
</div>
